import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityServiceService } from '../services/utility-service.service';
import {CarrierService} from '../services/carrier.service';
import { Account } from '../constants/account.enum';
import { Page } from '../classes/page';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertComponent } from '../popup/alert.component';
import { AuthWebService } from '../services/authweb.service';
import { CountryService } from '../services/country.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { isNumeric } from 'rxjs/util/isNumeric';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ca-contact-page',
  templateUrl: './ca-contact-page.component.html',
  styleUrls: ['./ca-contact-page.component.css']

})
export class CaContactPageComponent implements OnInit {

  contactDetails: any = {};
  sub: any;
  acc = Account;
  isDup = false;
  CarrierID: number;
  isEdit: boolean;
  user: any = {};
  dataCntrl: any = {activityData:{}};
  ddlCountries = [];
  lblHeading: string = "Contact Details";
 
  form: UntypedFormGroup;
  message: string;
  public isLoading = false;

  CurrentDate: Date;
  numberisvalid =false;

  constructor(public CarrierService: CarrierService, private router: Router, private msg: ToastrService,
    private route: ActivatedRoute, public utility: UtilityServiceService,
    private countryService: CountryService,  private authWebService: AuthWebService,private confirmDialogService: ConfirmDialogService) { }

  ngOnInit() {

    this.CarrierID = this.utility.ctrlPages[Account.First].carrierId;
    this.isEdit = this.utility.ctrlPages[Account.First].isEdit;
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : {};
    this.listCountries();

    this.createForm();

    this.CurrentDate = new Date();
    this.CurrentDate.setMonth(this.CurrentDate.getMonth() + 1);

    this.lblHeading = (!this.isEdit) ? "New Contact Details" : "Edit Contact Details";

    if (this.utility.ctrlPages[Account.First].carrierId) {
      this.initFormData();
    }

  }
  createForm = ()=> {
    this.form = new UntypedFormGroup({
      CarrierID: new UntypedFormControl(this.CarrierID)
      , RejectReason: new UntypedFormControl("")
      , is_active: new UntypedFormControl(this.contactDetails.is_active)      
      , FirstName: new UntypedFormControl(this.contactDetails.FirstName, Validators.maxLength(20))
      , LastName: new UntypedFormControl(this.contactDetails.LastName, Validators.maxLength(20))
      , EmailAddress: new UntypedFormControl(this.contactDetails.EmailAddress)
      , MobileNumber: new UntypedFormControl(this.contactDetails.MobileNumber)
      , CommunicationPreference: new UntypedFormControl(this.contactDetails.CommunicationPreference, Validators.required)
      , PhysicalAddress1: new UntypedFormControl(this.contactDetails.PhysicalAddress1,Validators.required)
      , PhysicalAddress2: new UntypedFormControl(this.contactDetails.PhysicalAddress2, Validators.required)
      , PhysicalAddress3: new UntypedFormControl(this.contactDetails.PhysicalAddress3)
      , Town: new UntypedFormControl(this.contactDetails.Town)
      , PostalCode: new UntypedFormControl(this.contactDetails.PostalCode, Validators.required)
      , CountryID: new UntypedFormControl(this.contactDetails.CountryID)
      , FaxNumber: new UntypedFormControl(this.contactDetails.FaxNumber)
      , OfficePhone: new UntypedFormControl(this.contactDetails.OfficePhone, Validators.required)
      , CompanyEmail: new UntypedFormControl(this.contactDetails.CompanyEmail, Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      , PostalAddress1: new UntypedFormControl(this.contactDetails.PostalAddress1, Validators.required)
      , PostalAddress2:  new UntypedFormControl(this.contactDetails.PostalAddress2, Validators.required)
      , PostalAddress3: new UntypedFormControl(this.contactDetails.PostalAddress3)  
      , pTown: new UntypedFormControl(this.contactDetails.Town, Validators.required)
      , pPostalCode: new UntypedFormControl(this.contactDetails.pPostalCode, Validators.required)
      , pCountry: new UntypedFormControl(this.contactDetails.pCountry)
      , pFaxNumber: new UntypedFormControl(this.contactDetails.pFaxNumber)
      , pOfficePhone: new UntypedFormControl(this.contactDetails.pOfficePhone, Validators.required)
      , pCompanyEmail: new UntypedFormControl(this.contactDetails.pCompanyEmail, Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      , role_served_ind: new UntypedFormControl(21)
      , date_role_from: new UntypedFormControl(new Date())
      , date_role_to: new UntypedFormControl(new Date())
      , datecreated: new UntypedFormControl(new Date())
      , datemodified: new UntypedFormControl(new Date())
      , usercreated: new UntypedFormControl(this.user.FirstName + ', ' + this.user.LastName)
      , usermodified: new UntypedFormControl(this.user.FirstName + ', ' + this.user.LastName)
      , id_type_ind: new UntypedFormControl(1)
      });    
  }

  initFormData = () => {
    if (this.utility.ctrlPages[Account.First].carrierId > 0) {
      this.isLoading = true;
      this.CarrierService.getContactDetails(this.utility.ctrlPages[Account.First].carrierId).subscribe(result => {
        this.contactDetails = result;
        //console.log(this.contactDetails);
        this.isLoading = false;
        (<UntypedFormGroup>this.form)
          .setValue({
          
             CarrierID: this.contactDetails.CarrierID
            , RejectReason: this.contactDetails.RejectReason
            , is_active: this.contactDetails.is_active     
            , FirstName: this.contactDetails.FirstName
            , LastName: this.contactDetails.LastName
            , EmailAddress: this.contactDetails.EmailAddress
            , MobileNumber: this.contactDetails.MobileNumber
            , CommunicationPreference: this.contactDetails.CommunicationPreference
            , PhysicalAddress1: this.contactDetails.PhysicalAddress1
            , PhysicalAddress2: this.contactDetails.PhysicalAddress2
            , PhysicalAddress3: this.contactDetails.PhysicalAddress3
            , Town: this.contactDetails.Town
            , PostalCode: this.contactDetails.PostalCode
            , CountryID: this.contactDetails.CountryID
            , FaxNumber: this.contactDetails.FaxNumber
            , OfficePhone: this.contactDetails.OfficePhone
            , CompanyEmail: this.contactDetails.CompanyEmail
            , PostalAddress1: this.contactDetails.PostalAddress1
            , PostalAddress2:  this.contactDetails.PostalAddress2
            , PostalAddress3: this.contactDetails.PostalAddress3 
            , pTown: this.contactDetails.pTown
            , pPostalCode: this.contactDetails.pPostalCode
            , pCountry: this.contactDetails.pCountry
            , pFaxNumber: this.contactDetails.pFaxNumber
            , pOfficePhone: this.contactDetails.pOfficePhone
            , pCompanyEmail: this.contactDetails.pCompanyEmail
            , role_served_ind: this.contactDetails.role_served_ind
            , date_role_from: this.contactDetails.date_role_from
            , date_role_to: this.contactDetails.date_role_to        
            , id_type_ind: this.contactDetails.id_type_ind
            , datecreated: new Date()
            , datemodified: new Date()
            , usercreated: this.user.FirstName + ', ' + this.user.LastName
            , usermodified: this.user.FirstName + ', ' + this.user.LastName            
          }, { onlySelf: true });
       
      }, error => {
        this.isLoading = false;
        //console.log(error);
      });
    }
      
  
  }
  listCountries = () => {
    this.isLoading = true;    
    this.countryService.listCountries().subscribe((result:any) => {
      this.ddlCountries = result;     
      this.isLoading = false; 
    }, error => {
      this.isLoading = false; 
      //console.log(error);
    });
  }
  checkMobileNumber(obj:any)
  {
    //check length
    
    if (obj.MobileNumber.trim().length >= 10) 
    {
  // how many spaces are in a string?
      var knt = obj.MobileNumber.trim().split(" ").length - 1;
      //console.log("what is the count");
      //console.log(knt);
      var str = new String(obj.MobileNumber.trim()); 
       for(let i =0;i<knt;i++)
       {
         str = str.replace(" ","");
  
       }
      
      //check char at first posn
      //console.log("number after trimming:");
      //console.log(str);
     if ( str.charAt(0) === '+') 
     {
       //remove + and check if rest can be converted to number
          if (isNumeric(str.slice(1)))
          {
            //first char is + does it follow
              if (str.slice(1).match('^27[0-9]{9}$'))
                {
                  //valid number
                  this.numberisvalid = true;
                  obj.MobileNumber=str;
  
                }
                else
                {
                  //not a match but starts with + perhaps a different country and is numeric
                  this.numberisvalid = true;
                  obj.MobileNumber=str;
                }
  
          }
          else
          {
            //not numeric and if you remove what chars - or ( or )
            var cnt_dash = str.split("-").length - 1;
            var cnt_open_parenthesis = str.split("(").length - 1;
            var cnt_close_parenthesis = str.split(")").length - 1;
            
            //remove dash
            for(let d=0;d<cnt_dash;d++)
            {
              str = str.replace("-","");
            }
            //remove (
            for(let e=0;e<cnt_open_parenthesis;e++)
            {
                str = str.replace("(","");
             }
            //remove )
            for(let f=0;f<cnt_close_parenthesis;f++)
            {
              str = str.replace(")","");
            }
             if (isNumeric(str))
             {
               // removed characters and we have number that starts with a +
               this.numberisvalid = true;
               obj.MobileNumber = "+"+str;
               //console.log("new number stripped and + ");
               //console.log(obj.MobileNumber)
             }
             else
             {
               this.numberisvalid = false;
             }
           
          }
       
     }
     else
     {
        //check if it is a number already
        if(isNumeric(str))
        {
           //chatAt(0) is not +
          // is it a regular number? 0892345678
  
            if (str.match('^0[1-9]{9}$'))
            {
              //it starts with a zero and valid number
              this.numberisvalid = true;
              obj.MobileNumber = "+27"+ str.slice(1);
              //console.log("new number");
              //console.log(obj.MobileNumber)
            }
            else
            {
              //it doesnt start with a 0 is it an international number?
              this.numberisvalid = true;
              obj.MobileNumber = "+" + str;
              //console.log("new number international");
              //console.log(obj.MobileNumber)
  
            }
  
        }
        else
        {
          //it is not a number remove the dashes - or ( or )
         
          var cnt_dash = str.split("-").length - 1;
          var cnt_open_parenthesis = str.split("(").length - 1;
          var cnt_close_parenthesis = str.split(")").length - 1;
          
          //remove dash
          for(let d=0;d<cnt_dash;d++)
          {
            str = str.replace("-","");
          }
          //remove (
          for(let e=0;e<cnt_open_parenthesis;e++)
          {
              str = str.replace("(","");
           }
          //remove )
          for(let f=0;f<cnt_close_parenthesis;f++)
          {
            str = str.replace(")","");
          }
  
           
          if (isNumeric(str))
          {
            // removed characters and we have number that starts with a +
            this.numberisvalid = true;
            obj.MobileNumber = "+"+str;
            //console.log("new number stripped and + ");
            //console.log(obj.MobileNumber)
          }
          else
          {
            this.numberisvalid = false;
          }
  
        }
      
     }
    }
    else
    {
      this.numberisvalid = false;
    }
  }
  onSubmit(obj:any) {
    if (this.isDup) { return; }
    this.checkMobileNumber(obj);
    
    if (!this.numberisvalid )
{
  this.msg.warning(`Carrier contact details for  ${obj.FirstName} where not saved. Please check the mobile number`);
  // this.dialogService.addDialog(AlertComponent, { title: `Carrier Contact details`, message: `Carrier contact details for  ${obj.FirstName} where not saved. Please check the mobile number`, bold: `${obj.LastName}` });
  return;
}
  
      this.message ="Saving Carrier contact details"; 
    this.isLoading = true;
 
    //console.log(obj);

    this.createContactDetails(obj);
  
  }
  
  copyTo() {

    this.form.patchValue({

      PostalAddress1: this.form.value.PhysicalAddress1,
      PostalAddress2: this.form.value.PhysicalAddress2,
      PostalAddress3: this.form.value.PhysicalAddress3,
      pTown: this.form.value.Town,
      pPostalCode: this.form.value.PostalCode,
      pCountry: this.form.value.CountryID,
      pFaxNumber: this.form.value.FaxNumber,
      pOfficePhone: this.form.value.OfficePhone,
      pCompanyEmail: this.form.value.CompanyEmail

    })
     
  }

  copyBack() {
    
    this.form.patchValue({

      PhysicalAddress1: this.form.value.PostalAddress1,
      PhysicalAddress2: this.form.value.PostalAddress2,
      PhysicalAddress3: this.form.value.PostalAddress3,
      Town: this.form.value.pTown,
      PostalCode: this.form.value.pPostalCode,
      CountryID: this.form.value.pCountry,
      FaxNumber: this.form.value.pFaxNumber,
      OfficePhone: this.form.value.pOfficePhone,
      CompanyEmail: this.form.value.pCompanyEmail

    })
  }

  IsSameUser(data:any) {
    //console.log(data);
    //this.form.patchValue({   
    //      FirstName: this.user.FirstName,
    //      LastName: this.user.LastName     
    //  })
  }

  selectedLevel;
  data: Array<Object> = [
    { id: "Email", name: "Email" },
    { id: "SMS", name: "SMS" }
  ];
   selected(){
    //console.log(this.selectedLevel)
  }
  createContactDetails = (obj: any) => {

    //console.log(obj);

    this.message = "Creating carrier account's company details,please wait...";
    this.isLoading = true;
    this.CarrierService.processContactDetails(obj).subscribe(result => {
      this.contactDetails = result;     
      this.utility.ctrlPages[Account.First].carrierId = this.contactDetails.CarrierID;
      //console.log(this.contactDetails);
      this.isLoading = false;
      this.msg.success(`Carrier contact details for  ${obj.FirstName} saved successfully.`)
    //  this.dialogService.addDialog(AlertComponent, { title: `Carrier Contact details`, message: `Carrier contact details for  ${obj.FirstName} saved successfully.`, bold: `${obj.LastName}` });
    }, error => {
      this.isLoading = false;
      //console.log(error);
      this.msg.error(`Failed to save Carrier contact details for  ${obj.FirstName}.`)
    //  this.dialogService.addDialog(AlertComponent, { title: `Carrier Contact details`, message: `Failed to save Carrier contact details for  ${obj.FirstName}.`, bold: `${obj.LastName}` });
      });

  }

}
